import { useState, useEffect } from 'react';
import { Row, Col } from "reactstrap";
import DownloadIcon from "../../../assets/DownloadIcon";
import SafeIcon from "../../../assets/SafeIcon";
import ThunderIcon from "../../../assets/ThunderIcon";
import GreenPenIcon from "../../../assets/GreenPenIcon";
import ButtonCommon from "../../../components/ButtonCommon";
import HeadingMain from "../../../components/Heading";
import InputCommon from "../../../components/InputCommon";
import microValidator from 'micro-validator'
import CustomAlerts from '../../../components/AlertCustom.js';
import { updateUserProfile, getOtp, confirmOtp, getPartnerData } from '../../../api/onboarding';
import CommonModal from "../../../components/CommonModal";
import moment from 'moment-timezone';
import OtpInput from "react-otp-input";
import './profile.scss'
import { Select, MenuItem, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, InputAdornment } from '@material-ui/core';
import { CloseOutlined } from "@material-ui/icons";

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CheckIcon from '@material-ui/icons/Check';


let loginValidationSchema = {
  firstName: {
      required: {
          errorMsg: 'First name is required'
      }
  },
  lastName: {
      required: {
          errorMsg: 'Last name required'
      },
  },
  phoneNumber: {
    required: {
        errorMsg: 'Phone number is required'
    },
  },
  dob: {
    required: {
        errorMsg: 'DOB is required'
    },
  }
}

const CustomRadio = (props) => {
  return <Radio
  {...props}
  sx={{
    color: 'green',
    '&.Mui-checked': {
      color: 'green',
    },
  }}
/>
}


const Profile = (props) => {
  const [form, setForm] = useState({firstName: '', lastName: '', dob: '', phoneNumber: '', "gender": ""});
  const [ error , setErrors ] = useState({firstName: '', lastName: '', dob: '', phoneNumber: ''});
  const [loading, setLoading] = useState('');
  const [confirmModal, setConfirmModal] = useState(false);
  const [OTP, setOTP]= useState("");
  const [partnerData, setPartnerData] = useState(null);

  const [seconds, setSeconds ] = useState(60);
  let myInterval;

  useEffect(()=>{
    myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(myInterval)
      } 
    }, 1000)
    return ()=> {
      clearInterval(myInterval);
    };
  });

  useEffect(() => {
    getPartnerData().then(res => {
      setPartnerData(res)
    })
  },[])

  const onChange = (value, key) => {
    let currentForm = {...form};
    currentForm[key] = value.trim() != "" ? value : "";
    error[key] = ''
    setForm(currentForm);
    setErrors({ ...error })
  }

  const onSubmit = () => {
    const errorsHandler = microValidator.validate(loginValidationSchema, form)
    if (Object.keys(errorsHandler).length) {
        setErrors(errorsHandler)
        return
    }

    setLoading('formLoading');
    getOtp(form.phoneNumber).then(res => {
      setSeconds(60);
      setConfirmModal(true);
    }).catch(err => {
      CustomAlerts({
          message : err.message,
          title:'Error',
          type:'danger'
      })
      setLoading('');
    })
  }

  const updateUser = () => {
    let formData = {...form};

    formData.dob = moment(formData.dob).format('DD/MM/yyyy');
    setLoading('formLoading');

    updateUserProfile(formData).then(res => {
      props.setUserData(res);
      props.setStep();
      setLoading('');
    }).catch((err) => {
      CustomAlerts({
        message : err,
        title:'Error',
        type:'danger'
      })
      setLoading('');
    })
  }

  const testOtp = () => {
    setLoading('otpLoading');
    confirmOtp(form.phoneNumber, OTP).then(res => {
      setConfirmModal(false);
      updateUser()
    }).catch(err => {
      CustomAlerts({
        message : err.message,
        title:'Error',
        type:'danger'
      })
      setLoading('');
    })
  }

  const isDisabled = () => {
    if (loading === 'formLoading') {
      return true;
    } else if (!form.firstName || 
      !form.lastName || 
      !form.dob ||
      !form.phoneNumber ||
      !form.gender) {
      return true
    }
    return false;
  }

  const resentOTP = () => {
    setSeconds(60);
    onSubmit()
  }

  const onCloseModal = () => {
    clearInterval(myInterval);
    setConfirmModal(false); 
    setLoading(false)
  }

  const renderPartnerDetails = () => {
    let partnerDetail = partnerData.emailId
    if(partnerData.firstName && partnerData.lastName) {
      partnerDetail += ' (' + partnerData.firstName + " " + partnerData.lastName + ')'
    }
    return partnerDetail
  }

  return (
    <section className="mainContent">
      <Row>
        <Col lg={{size: 8}}>
          <div className="formContainer">
            <h2>Enter Applicant details</h2>
            <Row>
              <Col md={6}>
                <label>First Name</label>
                <InputCommon 
                  helperText={error.firstName && error.firstName[0]}
                  error={error.firstName && error.firstName[0] ? true : false}
                  placeholder="Eg. Ramesh" 
                  onChange={(e) => onChange(e.target.value, 'firstName')}
                  value={form.firstName}
                />
              </Col>
              <Col md={6}>
                <label>Last Name</label>
                <InputCommon 
                  helperText={error.lastName && error.lastName[0]}
                  error={error.lastName && error.lastName[0] ? true : false}
                  placeholder="Eg. Kumar" 
                  onChange={(e) => onChange(e.target.value, 'lastName')}
                  value={form.lastName}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <label>Mobile number</label>
                <InputCommon 
                  type="number"
                  helperText={error.phoneNumber && error.phoneNumber[0]}
                  error={error.phoneNumber && error.phoneNumber[0] ? true : false}
                  placeholder="Eg. 9999999999"
                  onChange={(e) => onChange(e.target.value, 'phoneNumber')}
                  value={form.phoneNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <label>Date of Birth</label>
                <InputCommon 
                  helperText={error.dob && error.dob[0]}
                  type="date"
                  error={error.dob && error.dob[0] ? true : false}
                  onChange={(e) => onChange(e.target.value, 'dob')}
                  value={form.dob}
                  inputProps={{  max: "2020-01-01" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12} style={{marginBottom: 20}}>
                <label>Gender</label>
                <RadioGroup
                  aria-label="gender"
                  defaultValue="female"
                  name="radio-buttons-group"
                  onChange={(e) => onChange(e.target.value, 'gender')}
                  value={form.gender}
                  row
                >
                  <FormControlLabel value="female" control={<Radio color="info" />} label="Female" />
                  <FormControlLabel value="male" control={<Radio color="info" />} label="Male" />
                </RadioGroup>
              </Col>
            </Row>
            {partnerData?.userId &&
              <Row>
                <Col md={12}>
                  <label>
                    Loan account linked to below Tax Expert
                    <span className="helpIcon">
                      <HelpOutlineIcon />
                      <div className="toolTipBox">
                        <p>More information on role of tax experts</p>
                        <ul>
                          <li>Your Tax Expert can view basic details about your loan application such as available credit limit and disbursals</li>
                          <li>This enables them to help you while filings your GST return using ClearTax GST application</li>
                          <li>Don’t worry, your tax expert will not be able to disburse any amount from your credit line. This step will require your OTP confirmation</li>
                        </ul>
                      </div>
                    </span>
                  </label>
                  <div className="inputWithIcon">
                    <span className="inputIcon"><CheckIcon /></span>
                    <InputCommon 
                      value={renderPartnerDetails()}
                      disabled 
                    />
                  </div>
                </Col>
              </Row>
            }
            <ButtonCommon disabled={isDisabled()} title={loading === 'formLoading' ? "Loading..." : "Continue to check eligibility"} onClick={() => onSubmit()} />
          </div>
        </Col>
      </Row>

      <CommonModal className="confirmationModal" open={confirmModal}>
        <div onClick={() => {onCloseModal()}} className="modalCloseBtn">
          <CloseOutlined />
        </div>
        <div>
          <h5 style={{margin: '20px 0 30px 0', textAlign: 'center'}}>Enter OTP received on your mobile number</h5>
          <Col md={12}>
            <OtpInput
              value={OTP}
              onChange={(val) => setOTP(val)}
              numInputs={6}
              containerStyle="OTPCon"
              inputStyle="OTPInput"
            />
          </Col>
          <Row>
            <Col md={7}>
              <div className="linksCon">
                <p style={{marginBottom: -5}}>
                  <span className="userNameSpan">{form.phoneNumber}</span>
                  {seconds == 0 && 
                    <span className="cursorPointer" onClick={() => resentOTP()}>
                      Resend OTP
                    </span>
                  }
                </p>
              </div>
            </Col>
            <Col md={5}>
              {seconds !== 0 &&
                <p style={{float: 'right', margin: 0, marginTop: 20}}>
                  Resend OTP in 00:{seconds < 10 ? '0' :''}{seconds}
                </p>
              }
            </Col>
          </Row>
          <ButtonCommon disabled={loading === 'otpLoading'} style={{width: '100%'}} onClick={() => testOtp()} title={loading === 'otpLoading' ? "Verifing..." : "Verify"} />
        </div>
      </CommonModal>
    </section>
  )
}

export default Profile;